import {html, css} from 'lit'
import App from 'bui/app/tabbar'
import './overview'
 import './auftragsliste'
import './elements'
import './presenters'
// import './tools'
import './server'
import './components'
import './tools/docs'

customElements.define('demo-main', class extends App{

    static properties = {
        showModAuftragsliste: { type: Boolean },
        token: { type: Object }
    };

    static styles = [App.styles, css`
        :host {
            --b-app-tab-bar-bgd: var(--theme-bgd) !important;
        }
    `]

    constructor() {
        super();

        const tokenString = localStorage.getItem('laportal-token');
        this._toggleAuftragsliste(tokenString);        
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('storage', this._onStorageChange);   
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('storage', this._onStorageChange);
    }

    _toggleAuftragsliste(qToken) {   
        try {
            this.token = JSON.parse(qToken);
        } catch (e) {
            this.token = [];
        }

        if (this.token && this.token.length >= 1) {
            this.showModAuftragsliste = true;
        } else {
            this.showModAuftragsliste = false;
        }      
    }

    _onStorageChange = (event) => {
        if (event.key === 'laportal-token') {  
            this._toggleAuftragsliste(event.newValue);            
        }
    } 

    get views(){
        return html`
            demo-overview               
            ${this.showModAuftragsliste ? html`<mod-auftragsliste></mod-auftragsliste>` : '' }  
        `
    }
 
})

export default customElements.get('demo-main')